export const protobufPackage = "snapchat.snapdoc";
export enum AudioCodecFormat {
    AUDIO_UNSET = 0,
    AAC = 1,
    HEAAC = 2,
    OPUS = 3,
    UNRECOGNIZED = -1
}
export enum ImageCodecFormat {
    IMAGE_UNSET = 0,
    JPEG = 1,
    PNG = 2,
    WEBP = 3,
    HEIF = 4,
    AWEBP = 5,
    GIF = 6,
    UNRECOGNIZED = -1
}
export enum VideoCodecFormat {
    VIDEO_UNSET = 0,
    H264 = 1,
    HEVC = 2,
    AV1 = 3,
    VP9 = 4,
    UNRECOGNIZED = -1
}
